var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseTags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.59238 0.40762C9.04889 -0.135873 8.16771 -0.135873 7.62422 0.40762L5 3.03184L2.37578 0.40762C1.83229 -0.135874 0.951113 -0.135873 0.40762 0.40762C-0.135873 0.951113 -0.135874 1.83229 0.40762 2.37578L3.03184 5L0.40762 7.62422C-0.135873 8.16771 -0.135874 9.04889 0.40762 9.59238C0.951113 10.1359 1.83229 10.1359 2.37578 9.59238L5 6.96816L7.62422 9.59238C8.16771 10.1359 9.04889 10.1359 9.59238 9.59238C10.1359 9.04889 10.1359 8.16771 9.59238 7.62422L6.96816 5L9.59238 2.37578C10.1359 1.83229 10.1359 0.951114 9.59238 0.40762Z",
    fill: "#EB3D26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseTags);
export default __webpack_public_path__ + "static/media/closeTags.4961a311.svg";
export { ForwardRef as ReactComponent };